import { Login } from "../login";

export function ControlLogin() {
  return (
    <Login
      afterLoginPath="/start"
      registerPath="/register"
      resetPasswordPath="/reset-password"
    />
  );
}
